document.addEventListener('DOMContentLoaded', function () {
    $('.collection_switch .switch_item').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active').siblings().removeClass('active');
            let number = $(this).data('num');
            $(`.left_tags .tags_container[data-num = ${number}]`).show().siblings().hide();
        }
    });
});